import 'core-js/client/shim';
import 'reflect-metadata';
import 'ts-helpers';

import 'web-animations-js/web-animations.min';

require('zone.js/dist/zone');

if (process.env.ENV === 'build') {
  // Production

} else {
  // Development

  Error.stackTraceLimit = Infinity;

  require('zone.js/dist/long-stack-trace-zone');
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/polyfills.ts